<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_PUBLISHING_WORKS_ACTION_OPTION_WORKS_BULK_EDITING"
        :close="closeDialog"
        persistent
        maxDialogWidth="1500"
        maxCardHeight="800"
        :alvqa="alvqa"
    >
        <template v-slot:dialogActions>
            <v-container fluid>

                <!-- BULK EDITING row with CONVERT ROLE% and COPY SHARES -->
                <v-row>
                    <v-col cols="4">
                        <v-card elevation="1">
                            <v-card-title>
                                {{ $t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_CONVERT_SHARES')}}
                            </v-card-title>
                            <v-card-subtitle>
                                {{ $t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_CONVERT_SHARES_TEXT')}}
                            </v-card-subtitle>
                            
                            <v-card-text>
                                <v-row>
                                    <v-col cols="5">
                                        <BaseEditPageDropdown 
                                            :context="context"
                                            field="SocietyOwnShares"
                                            :label="$t('lang_PUBLISHING_WORKS_CAPTION_SOCIETY_OWN')" 
                                            :items="convertRoleToSocietyOwnShares" 
                                            :withMargin="false"
                                            :clearable="false"
                                            :alvqa="alvqa + '-dropdown-society-rules-own-shares'"
                                        />
                                    </v-col>
                                    <v-col cols="7" class="pt-6">
                                        <BaseButton 
                                            @click="convertRoleToIntlShares"
                                            label="START"
                                            :alvqa="alvqa+'-button-convert-role-to-intl'"
                                        />
                                        <span class="pl-2" v-if="convertRoleSharesInProgress" :alvqa="alvqa + '-copy-shares-result-text'">
                                            {{ $t('lang_GENERIC_CAPTION_RESULT_REPORT') + ': '}}
                                        </span>
                                        <span v-if="csvReportConvertRoleFilepath !== null">
                                            <BaseIcon 
                                                @click.stop="downloadReportConvertRole(csvReportConvertRoleFilepath)" 
                                                icon="cloud_download" 
                                                :tooltipText="$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')" 
                                                :alvqa="alvqa + '-icon-download-csv-report-bulk-edit-convert-role-to-int'" 
                                            />
                                        </span>
                                        <span class="pl-2" v-else-if="showConvertRoleSharesProgressBar">
                                            <v-progress-circular 
                                                size="16"
                                                width="2"
                                                color="dialogProgressbar"
                                                indeterminate
                                                :alvqa="alvqa + '-progress-bar-csv-report-bulk-edit-convert-role-to-int'" 
                                            ></v-progress-circular>
                                        </span>
                                        <span v-else>
                                            {{ statusOfConvertRoleShares }}
                                        </span>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-0">
                                    <v-col class="mt-0 pt-0">
                                        <BaseCheckbox 
                                            :context="context + 'CombineCAAndE'"
                                            :label="$t('lang_PUBLISHING_WORKS_CAPTION_COMBINE_CA_AND_E')" 
                                            hideDetails
                                            class="mt-0"
                                            :alvqa="alvqa + '-convert-role-shares-combine-ca-and-e'"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row class="mt-0">
                                    <v-col class="mt-0 pt-0">
                                        <BaseCheckbox 
                                            :context="context + 'PmrCollects100MR'"
                                            :label="$t('lang_PUBLISHING_WORKS_CAPTION_PMR_100_MR')" 
                                            hideDetails
                                            class="mt-0"
                                            :alvqa="alvqa + '-convert-role-shares-pmr-collects-100-mr'"
                                        />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="5">
                        <v-card elevation="1">
                            <v-card-title>
                                {{ $t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES')}}
                            </v-card-title>
                            <v-card-subtitle>
                                {{ $t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_TEXT')}}
                            </v-card-subtitle>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="4">
                                        <BaseEditPageDropdown 
                                            :context="context"
                                            field="SourceShare"
                                            :items="copySharesOwnSourceItems" 
                                            :label="$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_FROM')"
                                            :withMargin="false"
                                            :clearable="false"
                                            rules="required"
                                            :alvqa="alvqa + '-dropdown-copy-source-share'"
                                        />
                                        <span>{{ $t(msgRequiredSourceSharesCopy) }}</span>
                                    </v-col>
                                    <v-col cols="3">
                                        <BaseEditPageDropdown 
                                            :context="context"
                                            field="TargetShare"
                                            :items="copySharesTargetItems" 
                                            :label="$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_TO')"
                                            :withMargin="false"
                                            :clearable="false"
                                            rules="required"
                                            :alvqa="alvqa + '-dropdown-copy-target-share'"
                                        />
                                    </v-col>
                                    <v-col cols="5" class="pt-6">
                                        <BaseButton 
                                            :disabled="buttonDisabledCopyShares" 
                                            @click="copyShares('own')"
                                            label="lang_GENERIC_CAPTION_COPY"
                                            :alvqa="alvqa+'-button-copy-shares'"
                                        />
                                        <span class="pl-3" v-if="showResultCopyShares" :alvqa="alvqa + '-copy-shares-result-text'">
                                            {{ $t('lang_GENERIC_CAPTION_RESULT_REPORT')}}
                                        </span>

                                        <!-- CSV report file of COPY SHARES-->
                                        <span v-if="csvReportCopySharesFilepath !== null">
                                            <BaseIcon 
                                                @click.stop="downloadReportCopyShares(csvReportCopySharesFilepath)" 
                                                icon="cloud_download" 
                                                :tooltipText="$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')" 
                                                :alvqa="alvqa + '-icon-download-csv-report-bulk-edit-copy-shares'" 
                                            />
                                        </span>

                                        <span v-else-if="progressBarCopyShares" class="pl-2">
                                            <v-progress-circular 
                                                size="16"
                                                width="2"
                                                color="dialogProgressbar"
                                                indeterminate
                                                :alvqa="alvqa + '-progress-bar-csv-report-bulk-edit-copy-shares'" 
                                            ></v-progress-circular>
                                        </span>

                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>


                    <v-col cols="3">
                        <v-card elevation="1">
                            <v-card-title>
                                {{ $t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_CAPTION_COMBINE_E')}}
                            </v-card-title>
                            <v-card-subtitle>
                                {{ $t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_CAPTION_COMBINE_E_DESCRIPTION')}}
                            </v-card-subtitle>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="4">
                                        <BaseEditPageDropdown 
                                            :context="context"
                                            field="TargetShareCombineE"
                                            :items="listCombineEShareTypes" 
                                            :label="$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_TO')"
                                            :withMargin="false"
                                            :clearable="false"
                                            rules="required"
                                            :alvqa="alvqa + '-dropdown-combine-e-in-target-share'"
                                        />
                                        <span>{{ $t(msgRequiredTargetSharesCombineE) }}</span>
                                    </v-col>
                                    <v-col cols="5" class="pt-6">
                                        <BaseButton
                                            :disabled="buttonDisabledCombineE"
                                            @click="combineEShares"
                                            label="lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_CAPTION_COMBINE_E_BUTTON"
                                            :alvqa="alvqa+'-button-combine-e-shares'"
                                        />

                                        <span v-if="progressBarCombineEShares" class="pl-2">
                                            <v-progress-circular 
                                                size="16"
                                                width="2"
                                                color="dialogProgressbar"
                                                indeterminate
                                                :alvqa="alvqa + '-progress-bar-csv-report-bulk-edit-combine-e-shares'" 
                                            ></v-progress-circular>
                                        </span>

                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>

                </v-row>

                <!-- BULK EDITING row with FILL INTL%/ROLE% and calculate GEMA WORK SHARES -->
                <v-row>
                    <!-- FILL INTL%/ROLE% -->
                    <v-col cols="6">
                        <v-card elevation="1">
                            <v-card-title>
                                {{ $t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_CONVERT_TO_INTL')}}
                            </v-card-title>
                            <v-card-subtitle>
                                {{ $t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_CONVERT_TO_INTL_TEXT')}}
                            </v-card-subtitle>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="4">
                                        <BaseEditPageDropdown 
                                            :context="context"
                                            field="SourceShare"
                                            :items="copySharesSourceItems" 
                                            :label="$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_FROM')"
                                            :withMargin="false"
                                            :clearable="false"
                                            rules="required"
                                            :alvqa="alvqa + '-dropdown-fill-intl-source-share'"
                                        />
                                        <span>{{ $t(msgRequiredSourceSharesFill) }}</span>
                                    </v-col>
                                    <v-col cols="3">
                                        <BaseEditPageDropdown 
                                            :context="context"
                                            field="FillOriginalShares"
                                            :items="fillOriginalSharesTargetItems" 
                                            :label="$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_TO')"
                                            :withMargin="false"
                                            :clearable="false"
                                            rules="required"
                                            :alvqa="alvqa + '-dropdown-fill-target-original-shares'"
                                        />
                                    </v-col>
                                    <v-col cols="5" class="pt-6">
                                        <BaseButton 
                                            :disabled="buttonDisabledFillOriginalShares" 
                                            @click="fillOriginalShares()"
                                            label="lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_FILL_INTL_PERCENT"
                                            :alvqa="alvqa+'-button-fill-intl'"
                                        />
                                        <span class="pl-3" v-if="showResultFillOriginalShares" :alvqa="alvqa + '-convert-to-intl-result-text'">
                                            {{ $t('lang_GENERIC_CAPTION_RESULT_REPORT')}}
                                        </span>

                                        <!-- CSV report file of FILL INTL%-->
                                        <span v-if="csvReportFillOriginalSharesFilepath !== null">
                                            <BaseIcon 
                                                @click.stop="downloadReportFillOriginalShares(csvReportFillOriginalSharesFilepath)" 
                                                icon="cloud_download" 
                                                :color="fillOriginalSharesHasFailures ? 'standardBrownIcon' : 'iconStandard'"
                                                :tooltipText="fillOriginalSharesDownloadTooltip" 
                                                :alvqa="alvqa + '-icon-download-csv-report-bulk-edit-fill-intl'" 
                                            />
                                        </span>

                                        <span v-else-if="progressBarFillOriginalShares" class="pl-2">
                                            <v-progress-circular 
                                                size="16"
                                                width="2"
                                                color="dialogProgressbar"
                                                indeterminate
                                                :alvqa="alvqa + '-progress-bar-csv-report-bulk-edit-fill-intl'" 
                                            ></v-progress-circular>
                                        </span>

                                    </v-col>
                                </v-row>
                                <v-row class="mt-0">
                                    <v-col class="mt-0 pt-0">
                                        <BaseCheckbox 
                                            :context="context + 'CopyMrToPr'"
                                            :label="$t('lang_PUBLISHING_WORKS_CAPTION_CHECKBOX_COPY_MR_TO_PR')" 
                                            hideDetails
                                            class="mt-0"
                                            :alvqa="alvqa + '-populate-original-shares-copy-mr-to-pr'"
                                        />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="6">
                        <v-card elevation="1">
                            <v-card-title>
                                {{ $t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_REMOVE_SE_SHARE_TITLE') }}
                            </v-card-title>
                            <v-card-subtitle>
                                {{ $t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_REMOVE_SE_SHARE_TEXT') }}
                            </v-card-subtitle>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="3">
                                        <BaseEditPageDropdown 
                                            :context="context"
                                            field="RemoveSEShareType"
                                            :items="subPublishersShareTypesList" 
                                            :label="$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_CAPTION_SHARE_TYPE')"
                                            :withMargin="false"
                                            :clearable="false"
                                            :additionalFunction="toggleButtonRemoveSE"
                                            :alvqa="alvqa + '-dropdown-remove-se-share-type'"
                                        />
                                    </v-col>
                                    <v-col cols="6">
                                        <BaseEditPageDropdown 
                                            :context="context"
                                            field="RemoveSEField"
                                            :items="subPublishersList" 
                                            :label="$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_SELECT_SE_SHARE')"
                                            :withMargin="false"
                                            :clearable="true"
                                            :additionalFunction="toggleButtonRemoveSE"
                                            :alvqa="alvqa + '-dropdown-remove-se-share'"
                                        />
                                    </v-col>
                                    <v-col cols="3" class="pt-6">
                                        <BaseButton 
                                            :disabled="!buttonDisabledRemoveSE" 
                                            @click="removeSE()"
                                            label="lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_REMOVE_SE_SHARE"
                                            :alvqa="alvqa+'-button-remove-se-share'"
                                        />
                                        <span class="pl-3" v-if="showResultRemoveSE" :alvqa="alvqa + '-remove-se-share-result-text'">
                                            {{ $t('lang_GENERIC_CAPTION_RESULT_REPORT')}}
                                        </span>

                                        <!-- CSV report file of REMOVE SE SHARE -->
                                        <span v-if="csvReportRemoveSEFilepath !== null">
                                            <BaseIcon 
                                                @click.stop="downloadReportRemoveSE(csvReportRemoveSEFilepath)" 
                                                icon="cloud_download" 
                                                :tooltipText="$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')" 
                                                :alvqa="alvqa + '-icon-download-csv-report-bulk-edit-remove-se'" 
                                            />
                                        </span>

                                        <span v-else-if="progressBarRemoveSE" class="pl-2">
                                            <v-progress-circular 
                                                size="16"
                                                width="2"
                                                color="dialogProgressbar"
                                                indeterminate
                                                :alvqa="alvqa + '-progress-bar-csv-report-bulk-edit-remove-se'" 
                                            ></v-progress-circular>
                                        </span>

                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <WorksBulkEditingConfirmDialog ref="confirmDialog"/>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseCheckbox from '@/components/_base/BaseCheckbox'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseIcon from '@/components/_buttons/BaseIcon'
import WorksBulkEditingConfirmDialog from './WorksBulkEditingConfirmDialog'

import api from '@/api_alv'

export default {
    name: "WorksBulkEditingDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseCheckbox,
        BaseEditPageDropdown,
        BaseIcon,
        WorksBulkEditingConfirmDialog,
    },
    data() {
        return {
            context: "WorksBulkEditing",
            alvqa: 'publishing-works-action-option-works-bulk-editing-dialog',
            // showResultConvertRoleShares: false,
            convertRoleSharesInProgress:false,
            // switches to show/hide Copy Shares button, result text and progress bar
            buttonDisabledCopyShares: false,
            showResultCopyShares: false,
            progressBarCopyShares: false,
            // switches to show/hide Fill International button, result text and progress bar
            buttonDisabledFillOriginalShares: false,
            showResultFillOriginalShares: false,
            progressBarFillOriginalShares: false,
            // switches to show/hide RemoveSE button, result text and progress bar
            buttonDisabledRemoveSE: false,
            showResultRemoveSE: false,
            progressBarRemoveSE: false,
            // Messages for required fields (from source shares in copy and fill)
            msgRequiredSourceSharesCopy: "",
            msgRequiredSourceSharesFill: "",
            msgRequiredTargetSharesCombineE: "",
            mapShareTypeToText: {
                'own': this.$t('lang_GENERIC_CAPTION_OWN_PERCENT'),
                'manu': this.$t('lang_GENERIC_CAPTION_MANU_PERCENT'),
                'intl': this.$t('lang_GENERIC_CAPTION_INTL_PERCENT'),
                'role': this.$t('lang_GENERIC_CAPTION_ROLE_PERCENT'),
            },
            // switches to show/hide Combine E shares button, result text and progress bar
            showResultCombineE: false,
            progressBarCombineEShares: false,
            buttonDisabledCombineE: false,
            listCombineEShareTypes: [
                {
                    text: this.$t('lang_GENERAL_OWN_PERCENT'),
                    value: 'own',
                    alvqa: 'dropdown-combine-e-target-shares-own'
                },
                {
                    text: this.$t('lang_GENERAL_INTL_PERCENT'),
                    value: 'intl',
                    alvqa: 'dropdown-combine-e-target-shares-intl'
                },
            ]
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowWorksBulkEditingDialog },
            set(show) { this.$store.commit('setShowWorksBulkEditingDialog', show) }
        },
        actionToConfirm: {
            get() { return this.$store.getters.getWorksBulkEditingActionToConfirm },
            set(value) { this.$store.commit('setWorksBulkEditingActionToConfirm', value) }
        },
        csvReportCopySharesFilepath() { 
            let filePath = this.$store.getters.getBulkEditCopySharesReportCsv
            if (filePath) {
                this.progressBarCopyShares = false
                this.buttonDisabledCopyShares = false
            }
            return filePath
        },
        csvReportConvertRoleFilepath() { 
            let filePath = this.$store.getters.getBulkEditConvertRoleToSharesReportCsv
            if (filePath) {
                this.showConvertRoleSharesProgressBar = false
            }
            return filePath
        },
        csvReportFillOriginalSharesFilepath() { 
            let filePath = this.$store.getters.getBulkEditFillOriginalSharesReportCsv
            if (filePath) {
                this.progressBarFillOriginalShares = false
                this.buttonDisabledFillOriginalShares = false
            }
            return filePath
        },
        fillOriginalSharesHasFailures() {
            return this.$store.getters.getBulkEditFillOriginalSharesFailedCount > 0
        },
        fillOriginalSharesDownloadTooltip() {
            const download = this.$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')
            if (!this.fillOriginalSharesHasFailures) {
                return download
            }
            return download + ' (' + this.$t('lang_GENERIC_CAPTION_ERROR') + ': ' + this.$store.getters.getBulkEditFillOriginalSharesFailedCount + ')'
        },
        csvReportRemoveSEFilepath() { 
            let filePath = this.$store.getters.getBulkEditRemoveSEReportCsv
            if (filePath) {
                this.progressBarRemoveSE = false
                this.$store.dispatch('fetchWorkSubpublishers')
                this.buttonDisabledRemoveSE = false
            }
            return filePath 
        },
        copySharesTargetItems() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_TO_OWN'),
                    value: 'toOwn',
                    alvqa: 'dropdown-target-shares-to-own'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_TO_INTL'),
                    value: 'toIntl',
                    alvqa: 'dropdown-target-shares-to-intl'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_TO_ROLE'),
                    value: 'toRole',
                    alvqa: 'dropdown-target-shares-to-role'
                },
            ]
        },
        copySharesOwnSourceItems() {

            let societies = this.$store.getters.getSocieties
            let homeSocietyCode = JSON.parse(localStorage.getItem("userData"))['user']['homeSocietyCode']
			
            let userHomeSociety = societies.find(society => {
                return society.value.toString() === homeSocietyCode
            })

            if(userHomeSociety !== undefined){

                let societyName = this.$alvPlugin.getSocietyName(parseInt(userHomeSociety.value)) + '-' + this.$t('lang_GENERAL_CAPTION_SHARES')

                return [
                    {
                        text:  this.$t('lang_GENERIC_CAPTION_FROM_LOWERCASE') + ' ' + societyName,
                        value: userHomeSociety.value.toString(),
                        alvqa: 'dropdown-source-shares-from-' + userHomeSociety.text.toLowerCase()
                    },                
                ]
                
            }
        },
        copySharesSourceItems() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_FROM_GEMA'),
                    value: 'fromGEMA',
                    alvqa: 'dropdown-source-shares-from-gema'
                },                
            ]
        },
        convertRoleToSocietyOwnShares() {
            return [
                {
                    text: this.$t('lang_GENERIC_CAPTION_NONE'),
                    value: 'none',
                    alvqa: 'dropdown-convert-to-society-own-percent-none'
                },                
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_GEMA_OWN'),
                    value: 'gemaOwn',
                    alvqa: 'dropdown-convert-to-society-own-percent-gema'
                },                
            ]
        },
        subPublishersList() {
            let arrayOfSE = this.$store.getters.getWorksBulkEditingDetailsRemoveSEArray
            let selectedShareType = this.$store.getters.getWorksBulkEditingDetailsRemoveSEShareType 
            if (arrayOfSE) {
                return arrayOfSE.filter(item => item.shareType == selectedShareType)
            }
            else
                return []
        },
        subPublishersShareTypesList() {
            let arrayOfSE = this.$store.getters.getWorksBulkEditingDetailsRemoveSEArray
            let shareTypes = []
            if (arrayOfSE) {
                arrayOfSE.forEach(party => {
                    if (!shareTypes.some(obj => obj.value === party.shareType)) {
                        shareTypes.push({
                            text: this.mapShareTypeToText[party.shareType],
                            value: party.shareType
                        })
                    }
                })
            }
            return shareTypes
        },
        fillOriginalSharesTargetItems() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_WORKS_ACTION_BULK_EDITING_COPY_SHARES_TO_ROLE'),
                    value: 'toRole',
                    alvqa: 'dropdown-target-shares-to-role'
                }
            ]
        },      
        
        statusOfConvertRoleShares:{
            get() { return this.$store.getters.getBulkEditingStatusOfConvertRoleShares },
            set(value) { this.$store.commit('setBulkEditingStatusOfConvertRoleShares', value) }
        },
        showConvertRoleSharesProgressBar:{
            get() { return this.$store.getters.getBulkEditingShowConvertRoleSharesProgressBar },
            set(value) { this.$store.commit('setBulkEditingShowConvertRoleSharesProgressBar', value) }
        },
    },
    methods: {
        closeDialog() {
            // this.showResultConvertRoleShares = false
            this.statusOfConvertRoleShares = ''
            this.showConvertRoleSharesProgressBar = false
            this.convertRoleSharesInProgress = false
            this.showResultCopyShares = false
            this.showResultFillOriginalShares = false
            this.buttonDisabledFillOriginalShares = false
            this.buttonDisabledCopyShares = false
            this.showResultRemoveSE = false
            this.showDialog = false
            this.actionToConfirm = null
            this.$store.commit('setBulkEditConvertRoleToSharesReportCsv', null)
            this.$store.commit('setBulkEditCopySharesReportCsv', null)
            this.$store.commit('setBulkEditFillOriginalSharesReportCsv', null)
            this.$store.commit('setBulkEditRemoveSEReportCsv', null)
            this.$store.commit('setWorksBulkEditingDetailsRemoveSEArray', null)
            this.$store.commit('setWorksBulkEditingDetailsRemoveSEField', null)
        },
        convertRoleToIntlShares() {
            this.$store.dispatch('convertRoleToIntlShares', {dir: this.dir, context: this.context, ids: this.idAttributeName })
            this.convertRoleSharesInProgress = true
            // this.showResultConvertRoleShares = true
        },
        async copyShares() {
            // Check if user has selected correct source shares
            let societyFrom = this.$store.getters.getSocieties.find(society => {
                return society.value.toString() === this.$store.getters.getWorksBulkEditingDetailsSourceShare
            })
            if (societyFrom === undefined) {
                this.msgRequiredSourceSharesCopy = "lang_GENERAL_VALIDATION_MESSAGE_FIELD_REQUIRED"
                return
            } else this.msgRequiredSourceSharesCopy = ""

            this.actionToConfirm = "copyShares"
            const status = await this.$refs.confirmDialog.openDialog()
            if (status) {
                this.buttonDisabledCopyShares = true
                this.progressBarCopyShares = true
                this.showResultCopyShares = true
            }
        },
        async combineEShares() {
            this.buttonDisabledCombineE = true
            this.progressBarCombineEShares = true
            let shareTypeFrom = this.$store.getters.getWorksBulkEditingDetailsTargetShareCombineE

            if (shareTypeFrom === undefined) {
                this.msgRequiredTargetSharesCombineE = "lang_GENERAL_VALIDATION_MESSAGE_FIELD_REQUIRED"
                return
            } else this.msgRequiredTargetSharesCombineE = ""

            this.actionToConfirm = "combineEShares"
            const status = await this.$refs.confirmDialog.openDialog()
            if (status) {
                this.buttonDisabledCombineE = false
                this.progressBarCombineEShares = false
            }
        },
        removeSE() {
            this.buttonDisabledRemoveSE = false // disable button
            this.$store.commit('setBulkEditRemoveSEReportCsv', null)
            this.$store.dispatch('removeSE', {dir: this.dir, context: this.context, ids: this.idAttributeName })
            this.showResultRemoveSE = true
            // show progress animation
            this.progressBarRemoveSE = true
        },
        async fillOriginalShares() {
            // Check if user has selected correct source shares
            let societyFrom = this.copySharesSourceItems.find(society => {
                return society.value.toString() === this.$store.getters.getWorksBulkEditingDetailsSourceShare
            })
            if (societyFrom === undefined) {
                this.msgRequiredSourceSharesFill = "lang_GENERAL_VALIDATION_MESSAGE_FIELD_REQUIRED"
                return
            } else this.msgRequiredSourceSharesFill = ""

            this.actionToConfirm = "fillOriginalShares"
            const status = await this.$refs.confirmDialog.openDialog()
            if (status) {
                this.buttonDisabledFillOriginalShares = true
                this.progressBarFillOriginalShares = true
                this.showResultFillOriginalShares = true
            }
        },
        toggleButtonRemoveSE(selected) {
            if (selected)
                this.buttonDisabledRemoveSE = true;
            else
                this.buttonDisabledRemoveSE = false;
        },
        downloadReportCopyShares(path) {
            api.getFileFromALV(path)
            this.showResultCopyShares = false
            this.$store.commit('setBulkEditCopySharesReportCsv', null)
        },
        downloadReportConvertRole(path) {
            api.getFileFromALV(path)
            this.convertRoleSharesInProgress = false
            this.$store.commit('setBulkEditConvertRoleToSharesReportCsv', null)
        },
        downloadReportFillOriginalShares(path) {
            api.getFileFromALV(path)
            this.showResultFillOriginalShares = false
            this.$store.commit('setBulkEditFillOriginalSharesReportCsv', null)
        },
        downloadReportRemoveSE(path) {
            api.getFileFromALV(path)
            this.showResultRemoveSE = false
            this.$store.commit('setBulkEditRemoveSEReportCsv', null)
        },
    },
}

</script>